<div class="language" id="preload">
    <button aria-label="Button" mat-button class="language__es" [class.selected]="language == 'es'" (click)="setLanguage('es')"
        [disableRipple]="true">Es</button>
    <span class="language__span">|</span>
    <button aria-label="Button" mat-button class="language__en" [class.selected]="language == 'en'" (click)="setLanguage('en')"
        [disableRipple]="true">En</button>
</div>